export enum RgClientType {
    GeekAds = "0",
    GeekSearch = "1"
}